/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getCitiesByStates } from 'services/actions/cities_actions';
import { esferasOption, esferasOptions } from 'services/esferas_contracts';
import { States } from 'services/states';
import { CitiesTypes, StatesTypes } from 'store/modules/online_search_store/types';
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import { useDispatch, useSelector } from 'react-redux';
import { GetImmminence, SearchImmminence } from 'store/modules/get_dados_imminence_store/actions';
import { ApplicationState } from 'store';
import { ImminenceState } from 'store/modules/get_dados_imminence_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import companyId from 'services/company_id';
import { Container } from './styles';

interface IHandleDatesChange {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
}

interface BiddingDesertedSearchFormProps {
  page: number;
  setSearch: boolean | any;
  searchDesert: boolean;
}

const BiddingDesertedSearchForm = (props: BiddingDesertedSearchFormProps) => {
  const { page, setSearch, searchDesert } = props;

  const dispatch = useDispatch();
  const [object, setObject] = useState<string>('');
  const [statesList, setStatesList] = useState<Array<StatesTypes>>([]);
  const [cities, setCities] = useState<Array<CitiesTypes>>([]);
  const [citiesList, setCitiesList] = useState<Array<CitiesTypes>>([]);
  const [selectedEsfera, setSelectedEsfera] = useState<Array<esferasOption>>([]);
  const [startDate, setStartDate] = useState<moment.Moment | null>(null);
  const [endDate, setEndDate] = useState<moment.Moment | null>(null);
  const [focusedInput, setFocusedInput] = useState<FocusedInputShape | null>(null);
  const esfera = selectedEsfera.map((selectedEsfera) => selectedEsfera.value);
  const state = statesList?.map((statesList) => statesList.value);
  const cities_ids = cities?.map((cities) => cities.value);

  const { get_imminence } = useSelector<ApplicationState, ImminenceState>(
    (state) => state.session.get_imminence,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    (async () => {
      const statesIds = statesList.map((state: { value: number }) => state.value);
      if (statesIds.length > 0) {
        const citiesResponse = await getCitiesByStates(statesIds);
        setCitiesList(
          citiesResponse.map((city: any) => {
            return { label: `${city.name_sub} - ${city.acronym}`, value: city.id };
          }),
        );
      }
      if (statesIds.length === 0) setCitiesList([]);
    })();
  }, [statesList]);

  useEffect(() => {
    searchDesert &&
      dispatch(
        SearchImmminence(
          object,
          page,
          esfera,
          state,
          cities_ids,
          startDate && startDate.format('YYYY-MM-DD'),
          endDate && endDate.format('YYYY-MM-DD'),
        ),
      );
  }, [searchDesert, page]);

  useEffect(() => {
    setSearch(
      object !== '' ||
        statesList?.length !== 0 ||
        startDate !== null ||
        endDate !== null ||
        selectedEsfera.length !== 0,
    );
  }, [object, statesList, startDate, endDate, selectedEsfera]);

  const handleDatesChange = ({ startDate, endDate }: IHandleDatesChange) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const handleClick = async () => {
    dispatch(
      SearchImmminence(
        object,
        page,
        esfera,
        state,
        cities_ids,
        startDate && startDate.format('YYYY-MM-DD'),
        endDate && endDate.format('YYYY-MM-DD'),
      ),
    );
  };

  const handleReset = async () => {
    setObject('');
    setStatesList([]);
    setCities([]);
    setSelectedEsfera([]);
    setEndDate(null);
    setStartDate(null);
    dispatch(
      GetImmminence({
        stateImminence: get_imminence?.view_panel,
        page,
        companyId: companyId(profile),
      }),
    );
  };
  return (
    <Container>
      <div className="p-3 card mt-3">
        <div className="row">
          <div className="col-md-12 pr-2">
            <button type="button" className="btn btn-sm btn-link float-right" onClick={handleReset}>
              Limpar
            </button>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-12">
            <div>
              <label htmlFor="vigencia" className="m-0">
                Período
              </label>
            </div>
            <DateRangePicker
              disabled={false}
              startDate={startDate}
              startDateId="daterangepicker_start_date"
              endDate={endDate}
              endDateId="daterangepicker_end_date"
              onDatesChange={handleDatesChange}
              focusedInput={focusedInput}
              onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
              startDatePlaceholderText="Dê"
              endDatePlaceholderText="Até"
              hideKeyboardShortcutsPanel
              displayFormat="DD/MM/YYYY"
              isOutsideRange={() => false}
              showClearDates
              small
              numberOfMonths={1}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12">
            <label htmlFor="stateSearch" className="m-0">
              Estado
            </label>
            <Select
              name="StateSearch"
              isMulti
              value={statesList || ''}
              closeMenuOnSelect={false}
              onChange={(event) => setStatesList([...event])}
              options={States}
              placeholder="Selecione os Estados"
              className="basic-multi-select"
            />
          </div>
        </div>
        <div className="d-flex justify-content-between col-md-12 p-0 mb-3">
          <div className="float-right date-template">
            <button
              type="button"
              className="btn btn-sm btn-link pr-0"
              onClick={() => setStatesList(States)}
            >
              Todos os Estados
            </button>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-12">
            <label htmlFor="citySearch" className="m-0">
              Cidade
            </label>
            <Select
              name="CitySearch"
              isMulti
              closeMenuOnSelect={false}
              value={cities || ''}
              onChange={(event) => setCities([...event])}
              options={citiesList}
              noOptionsMessage={() => 'Selecione um estado'}
              placeholder="Selecione as Cidades"
            />
          </div>
        </div>
        <hr />
        <div className="row mb-3">
          <div className="col-md-12">
            <label className="m-0">Esfera</label>
            <Select
              isMulti
              name="esferas"
              options={esferasOptions}
              placeholder="Selecione as Esferas"
              classNamePrefix="select"
              className="basic-multi-select"
              onChange={(event) => setSelectedEsfera([...event])}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <label htmlFor="objetoSearch" className="m-0">
              Objeto
            </label>
            <input
              type="text"
              className="form-control"
              id="objetoSearch"
              placeholder="Pesquise por Objeto"
              value={object}
              onChange={(e) => setObject(e.target.value)}
            />
          </div>
          <div className="col-12 mt-3 mb-3 d-print-none">
            <button type="button" className="btn btn-primary w-100" onClick={() => handleClick()}>
              Pesquisar
            </button>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default BiddingDesertedSearchForm;
